import React, { useState } from 'react';

import { getPmImgSrc } from '../../../helpers/media';
import {
  usePromiseWrapper,
  useCustomTranslation,
} from '../../../helpers/hooks';
import Loader from '../../Loader';
import DelayedRedirect from '../../DelayedRedirect';

export default function PayMethodItem({
  id,
  name,
  defaultPayWay: { price, currency, id: pwId },

  selectPayWay,
  fetchPayWay,
  fetchPayWaysForPayMethod,
  validateCache,

  onRedirect,
}) {
  const [wrappedFetchPayWay, payWayLoading] = usePromiseWrapper({
    initPromise() {
      return fetchPayWay(pwId);
    },
    cached() {
      return validateCache('payWay', pwId);
    },
  });

  const [
    wrappedFetchPayWaysForPayMethod,
    payWaysForPayMethodLoading,
  ] = usePromiseWrapper({
    initPromise() {
      return fetchPayWaysForPayMethod(id);
    },
    cached() {
      return validateCache('payMethodPayWays', id);
    },
  });

  const [clicked, setClicked] = useState(false);
  const { urlFor } = useCustomTranslation();

  function handleClick() {
    selectPayWay(pwId);
    wrappedFetchPayWay();
    wrappedFetchPayWaysForPayMethod();
    setClicked(true);
    if (typeof onRedirect === 'function') onRedirect();
  }

  return (
    <>
      {clicked ? (
        payWayLoading || payWaysForPayMethodLoading ? (
          <Loader />
        ) : (
          <DelayedRedirect
            delay="450"
            push
            to={urlFor('payWaySelector', { payMethodId: id })}
          />
        )
      ) : null}
      <li onClick={handleClick}>
        <img src={getPmImgSrc(id)} alt="" />
        <p className="payments-methods__title">{name}</p>
        {price ? (
          <p className="payments-methods__commission">
            {price} {currency}
          </p>
        ) : null}
      </li>
    </>
  );
}
